import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {FloatObjectComponent} from './float-object.component'
import {FloatObjectService} from './float-object.service'

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [FloatObjectComponent],
  exports: [
    FloatObjectComponent,
  ],
  providers: [
    FloatObjectService
  ]
})
export class FloatObjectModule {
}
